import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { LogoIcon } from './logo-icon';
export const Logo = ({ size = 's', text = 'Deluge', ref, ...props }) => (_jsxs(Root, { size: size, ref: ref, ...props, children: [_jsx(LogoIcon, { size: AVATAR_SIZE_MAP[size] }), _jsx(Text, { "$size": size, className: size, children: text })] }));
const Root = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ size }) => (size === 's' ? 8 : size === 'm' ? 8 : 10)}px;
  text-decoration: none;
`;
const Text = styled.span `
  color: ${(props) => props.theme.color.white[100]};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  font-size: ${({ $size }) => ($size === 's' ? 16 : $size === 'm' ? 24 : 32)}px;
`;
const AVATAR_SIZE_MAP = {
    l: 50,
    m: 40,
    s: 30,
    xs: 30,
    xxs: 30,
};
//# sourceMappingURL=logo.js.map